<script setup lang="ts">
withDefaults(defineProps<{
  photo?: 1 | 2 | 3
  color?: 'blue' | 'white'
}>(), {
  photo: 1,
  color: 'blue',
})
const fileIds = [
  'c638ab9e-878a-4527-a2e4-dd85cfc95e92',
  '5dc0bb65-1398-4b27-9c4d-e4b0574975a2',
  '26e2f733-2a66-41d6-8772-3d6feffec1f6',
]
</script>

<template>
  <template v-if="color === 'blue'">
    <div class="absolute-inset from-icsblue/62 to-62% bg-linear-to-t mix-blend-multiply -z-1" />
    <div class="absolute-inset from-icscyan/62 bg-linear-to-b mix-blend-overlay -z-2" />
    <div class="absolute-inset from-icsblue/62 bg-linear-to-t mix-blend-overlay -z-3" />
    <div class="absolute-inset -z-4 dark:backdrop-brightness-62" />
  </template>
  <template v-else-if="color === 'white'">
    <div class="absolute-inset from-white/90 to-white/90 via-white/70 bg-linear-to-b -z-1" />
    <div class="bg-icscyan absolute-inset mix-blend-soft-light -z-2" />
    <div class="absolute-inset backdrop-brightness-162 backdrop-grayscale -z-3" />
  </template>
  <NuxtImg
    :src="fileIds[photo - 1]"
    alt="A decorative background featuring the Rocky Mountain range found near the ICS headquarters."
    class="absolute-inset object-cover contrast-38 size-full -z-5"
    :class="{
      'object-[0_10%]': photo === 2,
      'object-[0_20%]': photo === 3,
    }"
  />
</template>
